import React, { useEffect, useState } from "react";
import { Container, Row, Col, Image, Modal } from "react-bootstrap";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import config from "../../config";
import axios from "axios";
import { getRatingPercentage } from "../../Utils/utils";
import { Link } from "react-router-dom";

const CustomerSpeak = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [our_customers_saying_data, setOur_customers_saying_data] = useState(
    []
  );
  const [hear_from_our_customers_data, setHear_from_our_customers_data] =
    useState([]);
  const [share_your_experience_data, setShare_your_experience_data] = useState(
    []
  );


  useEffect(() => {
    document.title = `Customer Speak | Agile Seekers`;
    document.getElementById("bodywrap").className = "cuspmain";

    // Define your API URL
    const apiUrl = `${config.API_BASE_URL}/customer_speak`;

    // Make the POST request using axios
    axios
      .post(apiUrl, {})
      .then((response) => {
        if (response.data.status === 1) {
          setOur_customers_saying_data(response.data.data.our_customers_saying);
          setHear_from_our_customers_data(
            response.data.data.hear_from_our_customers
          );
          setShare_your_experience_data(
            response.data.data.share_your_experience
          );
        } else {
          setError("Failed to load content");
          console.error("Error:", response.data.message);
        }
        setLoading(false); // Hide loading indicator
      })
      .catch((error) => {
        console.error("Axios Error:", error);
      });
  }, []);

  var settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const settings2 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    centerMode: true,

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const [showProfessionals, setShowProfessionals] = useState(false);
  const [modalData, setModalData] = useState({ name: "", image: "", description: "" });
  const [expanded, setExpanded] = useState({});

  const handleOpenProfessionals = (item) => {
    setModalData({
      name: item.name,
      image: item.image,
      description: item.description.replace(/<[^>]*>/g, ''), // Remove HTML tags
    });
    setShowProfessionals(true);
  };

  const handleCloseProfessionals = () => {
    setShowProfessionals(false);
    setModalData({ name: "", image: "", description: "" });
  };

  return (
    <>
      <Navbar />

      <section className="csmainwrap">
        <Container fluid>
          <Row className="cstitle">
            <Col>
              <h3>Hear from Our Certified Professionals</h3>
            </Col>
          </Row>
          <Row>
            <Col>
              <Slider {...settings2}>
                {loading && (
                  <Col md={4} className="hm-testimain">
                    Loading...
                  </Col>
                )}
                {!loading && error && <div>{error}</div>}
                {!loading &&
                  !error &&
                  our_customers_saying_data.map((item, index) => (
                    <Col
                      md={4}
                      id={item.id}
                      key={index}
                      className="hm-testimain"
                    >
                      <Col className="testibox">
                        <div className="rating_bar">
                          <div
                            className="rating-dis"
                            style={{
                              width: `${getRatingPercentage(item.rating)}%`,
                            }}
                          ></div>
                        </div>
                        {/* Toggle Description */}
                        {/* <ReadMoreToggle
                          description={item.description}
                        /> */}

                        <div
                          className={item.description.length <= 100 ? "testi-cont-box" : ""}
                          dangerouslySetInnerHTML={{
                            __html: expanded[index]
                              ? `<p>"${item.description
                                .replace(/<[^>]*>/g, '') // Remove all HTML tags
                                .trim()}"</p>` // Wrap the cleaned content in a <p> tag
                              : `<p class="testi-p">"${item.description
                                .replace(/<[^>]*>/g, '') // Remove all HTML tags
                                .slice(0, 100)
                                .trim()}${item.description.length > 100 ? '...' : ''}"</p>`, // Truncate if necessary
                          }}
                        />
                        {item.description.length > 100 && (
                          <div className="read-more-main">
                            <span
                              className="read-more"
                              // onClick={() => toggleContent(index)}
                              onClick={() => handleOpenProfessionals(item)}

                            >
                              {expanded[index] ? " Read less" : " Read more"}
                            </span>
                          </div>
                        )}


                        <div>
                          <div>
                            <h4>{item.name}</h4>
                            <h5>{item.designation}</h5>
                          </div>
                          <a
                            href={item.linkedin_url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Image
                              src={`${config.BASE_URL}/assets/images/linkedin-blue.png`}
                              className="img-fluid"
                              alt="linkedin-blue"
                            />
                          </a>
                        </div>
                      </Col>
                      <div className="testiborder"> </div>
                      <div className="testiuserbox">
                        <div
                          style={{ backgroundImage: `url(${item.image})` }}
                        ></div>
                      </div>
                    </Col>
                  ))}
              </Slider>
            </Col>
          </Row>
        </Container>

        <Container>
          <Row className="cstitle">
            <Col>
              {/* <h3>Want to share your experience with us?</h3>
              <p>Submit Your Testimonial</p> */}
            </Col>
          </Row>
        </Container>

        <Container>
          <Row>
            {loading && <Col>Loading...</Col>}
            {!loading && error && <Col>{error}</Col>}
            {!loading &&
              !error &&
              share_your_experience_data.map((item, index) => {
                // Generate YouTube video ID and thumbnail URL
                const videoId = new URLSearchParams(
                  new URL(item.youtube_url).search
                ).get("v");
                const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/0.jpg`;

                return (
                  <Col md={3} sm={6} xs={6} id={item.id} key={index}>
                    <Row className="playbox">
                      <Col>
                        <a
                          href={item.youtube_url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Image
                            src={thumbnailUrl}
                            alt={`Thumbnail for video ${item.id}`}
                            className="img-fluid"
                          ></Image>
                          <Image
                            src="assets/images/play.png"
                            className="img-fluid playicn"
                            alt="play"
                          />
                        </a>
                      </Col>
                    </Row>
                  </Col>
                );
              })}
          </Row>
        </Container>
      </section>

      {/* Hear from Our Certified Professionals Description Modal */}
      <Modal
        show={showProfessionals}
        onHide={handleCloseProfessionals}
        centered
        className="thank-popup"
        backdrop="static"
      >
        <Modal.Body>
          <Col>
            {/* <Image src={modalData.image} className="img-fluid mb-3" alt={modalData.name} /> */}
            {/* <h3>{modalData.name}</h3> */}
            <p>"{modalData.description}"</p>
            <Link onClick={handleCloseProfessionals} className="btn btn-primary">OK</Link>
          </Col>
        </Modal.Body>
      </Modal>

      <Footer />
    </>
  );
};
export default CustomerSpeak;
